module.exports = __webpack_public_path__ + "static/img/stay-option-icon-storage.773a73b3.svg";